import styled from 'styled-components'
import { getDropdownItemStyles } from '../style'
import { DropdownItemProps } from '../type'

const StyledDropdownItem = styled.div.withConfig({
    shouldForwardProp: (prop) => !['isSelected'].includes(prop)
})<DropdownItemProps>`
    ${getDropdownItemStyles}
`

export default StyledDropdownItem
